export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_DOCUMENT_LOADING = 'SET_DOCUMENT_LOADING';
export const SET_DOCUMENTS_LOADING = 'SET_DOCUMENTS_LOADING';
export const SET_PROJECT_LOADING = 'SET_PROJECT_LOADING';
export const SET_PROJECTS_LOADING = 'SET_PROJECTS_LOADING';
export const SET_SECURITY_LOADING = 'SET_SECURITY_LOADING';
export const SET_GROUPS_LOADING = 'SET_GROUPS_LOADING';
